export const scrollToElement = (id, offsetY = 80) => {
  const el = document.getElementById(id);
  if (el) {
    window.scrollTo({ top: el.offsetTop - offsetY, behavior: 'smooth' });
  }
};
